module.exports = __webpack_public_path__ + "static/chatbubbles-48db41db4140f72dd49ae8634e10c39a.png";